module.exports = __webpack_public_path__ + "img/filter.e87e09c6.png";